/**
 * Ленивая загрузка Yandex Maps API — по требованию, а не тегом в <head>
 * на каждой странице сайта (см. loadScriptOnce).
 */
import { loadScriptOnce } from './loadScriptOnce'

const API_KEY = '1ec10628-996b-4311-8298-9737d9883816'
const SCRIPT_SRC = `https://api-maps.yandex.ru/2.1/?apikey=${API_KEY}&lang=ru_RU`
const SCRIPT_ID = 'yandex-maps-api'

/**
 * Гарантирует, что window.ymaps загружен И готов (ymaps.ready отработал).
 * Возвращает сам ymaps, чтобы вызывающий код не лез в window повторно.
 */
export async function ensureYandexMaps(): Promise<any> {
  const loaded = (globalThis as any).window?.ymaps
  if (!loaded?.Map) {
    await loadScriptOnce(SCRIPT_SRC, { id: SCRIPT_ID })
  }

  const ymaps = (window as any).ymaps
  if (!ymaps) throw new Error('Yandex Maps API загрузился без window.ymaps')

  // ymaps.ready дожидается инициализации модулей: без него new ymaps.Map падает.
  return new Promise((resolve) => ymaps.ready(() => resolve(ymaps)))
}
